import React from "react";
import "./skeleton.scss"; // Import CSS file for styling
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';


const AppDetailSkeleton = () => {
  return (
    <div className=" container  bg-color " >


      {/* For variant="text", adjust the height via font-size */}


      {/* For other variants, adjust the size with `width` and `height` */}

      <div className="container">
      <Grid container spacing={4} style={{ paddingBottom: '50px', paddingTop: '150px', }}>

<Grid item xs={6} md={4}>
  <Skeleton variant="rounded" animation="wave" height={400}  />
</Grid>
<Grid item xs={6} md={8} style={{}}>
  <Skeleton variant="rounded" height={400} />
</Grid>
</Grid>
      </div>

      <div className="container">
      <Grid >
        <Skeleton animation="wave" height={100} width={360} />
        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
          {Array.from(Array(6)).map((_, index) => (
            <Grid item xs={2} sm={4} md={4} key={index}>
              <Skeleton animation="wave" height={50} width={260} />

            </Grid>
          ))}
        </Grid>




      </Grid>
      </div>
     
     
      <div className="container" style={{  }}>
        <Skeleton animation="wave" height={100} />
        <Skeleton animation="wave" height={300} />
      </div>



      {/* Add more shimmer divs for additional lines */}
    </div>
  );
};

export default AppDetailSkeleton;
